// @flow
import React, { useState, useRef, FC } from 'react';

import HtmlEditor from '../../components/HtmlEditor';
import Button from '../../components/Button';
import Tooltip from '../../components/Tooltip';
import translate from '../../translate';
import { getImages, removeImage, uploadImages } from './functions';
import MUIDialog from '@mui/material/Dialog';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { Typography } from '@mui/material';

export interface DetailPropsType {
    data: any;
    changeValue: any;
}

const EmailEditorBlock: FC<DetailPropsType> = (props) => {
    const [open, setOpen] = useState(false);
    const htmlEditor = useRef(null);

    const onClose = () => {
        // @ts-ignore
        props.changeValue(htmlEditor.current?.getTemplate() || '', 'html_content', false);
        setOpen(false);
    };

    const onOpen = () => {
        setOpen(true);
    };
    if (!open) {
        return (
            <Button color="primary" variant="contained" onClick={onOpen}>
                <Tooltip title={translate('emailTemplateDetail.templateEditor')}>
                    <ContactMailIcon />
                </Tooltip>
            </Button>
        );
    }

    return (
        <MUIDialog
            open={open}
            onClose={onClose}
            aria-labelledby="email-template-editor"
            aria-describedby="email-template-editor"
            fullScreen
        >
            <div>
                <div style={{display: "flex", columnGap: "5px", justifyContent: "right", margin: "10px"}}>
                    <Tooltip title={translate('dialog.close')}>
                        <HighlightOffIcon onClick={onClose} />
                    </Tooltip>
                </div>
                <Typography variant="h6">{props.data.name}</Typography>
            </div>
            <HtmlEditor
                html_content={props.data?.html_content || ''}
                ref={htmlEditor}
                getImages={getImages}
                uploadImages={uploadImages}
                removeImage={removeImage}
            />
        </MUIDialog>
    );
};

export default EmailEditorBlock;
